<template>
  <div :class="{ 'quick-filter': arg.filter.quickFilter, filter: !arg.filter.quickFilter }">
    <template v-if="arg.filter.type !== FilterTypes.COMPONENT">
      <!--     Fully dynamic arg.filters     -->

      <KeepAlive v-if="arg.filter.type === FilterTypes.SELECT">
        <WdsSelect
          v-model="model"
          :list="arg.filter.list"
          class="tw-w-full"
          :placeholder="arg.filter.placeholder"
          :label="arg.filter.quickFilter ? '' : $t(fieldToReadAble(arg.filter.title))"
          :max-labels-visible="arg.filter.quickFilter ? 1 : 10"
          :multi-select="arg.filter.multiSelect"
          labels-primary
          can-deselect
        />
      </KeepAlive>
      <KeepAlive v-if="arg.filter.type === FilterTypes.TOGGLE">
        <WdsToggle
          v-model:checked="model"
          :label="arg.filter.quickFilter ? '' : $t(fieldToReadAble(arg.filter.title))"
        />
      </KeepAlive>

      <KeepAlive v-if="arg.filter.type === FilterTypes.SINGLE_STRING">
        <WdsInput
          v-model="model"
          :label="arg.filter.quickFilter ? '' : $t(fieldToReadAble(arg.filter.title))"
        />
      </KeepAlive>
    </template>
    <template v-else>
      <KeepAlive>
        <component :is="arg.filter.component" v-model="model" :meta="arg" />
      </KeepAlive>
    </template>
  </div>
</template>

<script lang="ts" setup>
import { WdsInput, WdsSelect, WdsToggle } from '@worksome/wds-components'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { fieldToReadAble } from '@/components/GraphqlDataTable/tools'
import { FilterTypes } from '@/components/GraphqlDataTable/filters/filter-enums'
import { FilterMetaDataProp } from '@/components/GraphqlDataTable/filters/types'

defineProps<{
  arg: FilterMetaDataProp
}>()

const model = defineModel<any>()
</script>

<style lang="scss" scoped>
.filter {
  flex-grow: 1;
  max-width: 100%;
  min-width: 45%;
}

.quick-filter {
  flex-grow: 1;
  max-width: 100%;
}

.filter:has(.filter-full-width) {
  @apply tw-w-full;
}
</style>
